import { Console } from "console";
<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <!-- Toggler Button -->
    <b-link class="nav-link modern-nav-toggle">
      <feather-icon
        :icon="collapseTogglerIconFeather"
        size="18"
        class="d-none d-xl-block collapse-toggle-icon ml-auto"
        @click="toggleCollapsed"
      />
      <feather-icon
        icon="XIcon"
        size="18"
        class="d-block d-xl-none"
        @click="toggleVerticalMenuActive"
      />
    </b-link>

    <div class="navbar-header expanded" style="height: max-content">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link class="navbar-brand" to="/home">
              <span class="brand-logo" v-if="!userData.institutoLogo">
                <b-img
                  :src="appLogoImage"
                  alt="logo"
                  variant="light-primary"
                  badge
                  class="badge-minimal"
                  badge-variant="success"
                />
              </span>
              <span class="brand-logo" v-if="userData.institutoLogo">
                <b-img
                  :src="userData.institutoLogo"
                  alt="logo"
                  variant="light-primary"
                  badge
                  class="badge-minimal"
                  badge-variant="success"
                />
              </span>
              <h2 class="brand-text mb-0" style="text-wrap: wrap">
                {{ retornarNomeSistema }}
              </h2>
            </b-link>
          </li>
        </ul>

        <ul class="flex-row">
          <li class="nav-item brand-text">
            <div style="margin-left: -8px" v-if="apagaSelector">
              <b-link class="navbar-brand">
                <span id="tituloInstituto" class="brand-text mb-0">{{
                  getNomeInstituto()
                }}</span>
              </b-link>
            </div>

            <div style="margin-left: -8px" v-else-if="!apagaSelector">
              <instituto-selecionado />
            </div>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom"></div>
    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        evt => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>

    <!-- /main menu content-->
  </div>
</template>

<script>
import { BAvatar, BImg, BLink } from 'bootstrap-vue';
import navMenuItems from '@/navigation/vertical';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { provide, computed, ref } from '@vue/composition-api';
import useAppConfig from '@core/app-config/useAppConfig';
import { $themeConfig } from '@themeConfig';
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue';
import useVerticalNavMenu from './useVerticalNavMenu';
import InstitutoSelecionado from '@/@core/layouts/components/app-navbar/components/InstitutoSelecionado.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BAvatar,
    BImg,
    InstitutoSelecionado,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
      aberto: true,
    },
  },
  computed: {
    ...mapGetters({
      userData: 'user/userData',
    }),
    retornarNomeSistema: {
      get: function () {
        const aux = JSON.parse(localStorage.getItem('userData'));
        return aux?.institutoSelecionadoData?.nomeSistema != undefined
          ? aux?.institutoSelecionadoData?.nomeSistema
          : ``;
      },
      set: function (newValue) {
        return newValue;
      },
    },
  },
  data() {
    return {
      apagaSelector: false,
      navMenuItems: navMenuItems(),
    };
  },
  watch: {
    userData: function () {
      this.navMenuItems = navMenuItems();
    },
  },
  mounted() {
    this.$root.$on('hideMenuItens', () => (this.navMenuItems = []));

    if (this.userData.role != 'master') {
      if (this.userData.institutoId?.length == 1) {
        this.apagaSelector = true;
      }
    }

    const tamanhoNomeInstituto =
      this.userData.instituto && this.userData.instituto[0]?.nome?.length;
    const elementoNomeInstituto = document.querySelector(
      '#espacoDinamicoNomeInstituto'
    );

    if (elementoNomeInstituto) {
      if (tamanhoNomeInstituto > 23 && tamanhoNomeInstituto < 45)
        elementoNomeInstituto.classList.add('institutoNomeGrandeInicial23');
      else if (tamanhoNomeInstituto > 45)
        elementoNomeInstituto.classList.add('institutoNomeGrandeInicial45');
    }
  },
  methods: {
    getNomeInstituto() {
      try {
        return this.userData.instituto[0]?.nome?.trim();
      } catch (error) {
        console.log('error', error);
      }
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide('isMouseHovered', isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'
    );

    // App Name
    const { appName, appLogoImage } = $themeConfig.app;

    return {
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    };
  },
};
</script>

<style lang="scss">
#tituloInstituto {
  white-space: break-spaces !important;
}

.institutoNomeGrandeInicial23 {
  margin-bottom: 90px !important;
}

.institutoNomeGrandeInicial45 {
  margin-bottom: 120px !important;
}
@import '~@core/scss/base/core/menu/menu-types/vertical-menu.scss';
</style>
